var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: !_vm.detailMedicationVisible ? 12 : 6 } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-1",
                    label: "Tipo de producto:",
                    "label-for": "input-reason"
                  }
                },
                [
                  _c("base-select", {
                    attrs: {
                      options: _vm.medicationCombo.options,
                      label: "text",
                      valueProp: "value"
                    },
                    model: {
                      value: _vm.medicationCombo.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.medicationCombo, "selected", $$v)
                      },
                      expression: "medicationCombo.selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.medicationCombo.selected == 1
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "input-group-2",
                        label: "Tipo de prescripción:",
                        "label-for": "input-prescription"
                      }
                    },
                    [
                      _c("base-select", {
                        attrs: {
                          label: "text",
                          options: _vm.prescriptionCombo.options,
                          dataAttributes: [{ key: "key", value: "label" }]
                        },
                        model: {
                          value: _vm.prescriptionCombo.selected,
                          callback: function($$v) {
                            _vm.$set(_vm.prescriptionCombo, "selected", $$v)
                          },
                          expression: "prescriptionCombo.selected"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 1 &&
              _vm.prescriptionCombo.selected == 1
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "input-group-3",
                        label: "Medicamento:",
                        "label-for": "input-medicament"
                      }
                    },
                    [
                      _c("vue-bootstrap-typeahead", {
                        attrs: {
                          data: _vm.medications,
                          serializer: function(s) {
                            return s.nombreComercial
                          },
                          maxMatches: _vm.maxMatches,
                          placeholder:
                            "Teclee el nombre del medicamento y se buscará en el vademecum"
                        },
                        on: {
                          hit: function($event) {
                            _vm.selectedMedication = $event
                          },
                          input: _vm.onKeywordChanged
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "suggestion",
                              fn: function(ref) {
                                var data = ref.data
                                var htmlText = ref.htmlText
                                return [
                                  _c("b-row", { attrs: { cols: "12" } }, [
                                    _c("span", {
                                      domProps: { innerHTML: _vm._s(htmlText) }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                "Laboratorio: " +
                                                  data.laboratorio
                                                    .nombreComercializador
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                " Contenido: " +
                                                  data.unidadesContenido +
                                                  " " +
                                                  data.formafarmaceutica
                                                    .nombreSimplificado
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1843300622
                        ),
                        model: {
                          value: _vm.medicationSearch,
                          callback: function($$v) {
                            _vm.medicationSearch = $$v
                          },
                          expression: "medicationSearch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 1 &&
              _vm.prescriptionCombo.selected == 2
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "input-group-3",
                        label: "Principio Activo:",
                        "label-for": "input-principioActivo"
                      }
                    },
                    [
                      _c("vue-bootstrap-typeahead", {
                        attrs: {
                          data: _vm.desplegablePrincipiosActivos,
                          serializer: function(s) {
                            return s.nombre
                          },
                          maxMatches: _vm.maxMatches,
                          placeholder:
                            "Teclee el nombre del principio activo y se buscará en la base de datos"
                        },
                        on: {
                          hit: function($event) {
                            _vm.selectedMedication = $event
                          },
                          input: _vm.onKeywordChanged
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "suggestion",
                              fn: function(ref) {
                                var htmlText = ref.htmlText
                                return [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-sm" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(htmlText)
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          871923089
                        ),
                        model: {
                          value: _vm.principioActivoSearch,
                          callback: function($$v) {
                            _vm.principioActivoSearch = $$v
                          },
                          expression: "principioActivoSearch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 2
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "input-group-4",
                        label: "Producto sanitario:",
                        "label-for": "input-medicament"
                      }
                    },
                    [
                      _c("vue-bootstrap-typeahead", {
                        attrs: {
                          data: _vm.desplegableProductosSanitarios,
                          serializer: function(s) {
                            return s.nombre
                          },
                          maxMatches: _vm.maxMatches,
                          placeholder:
                            "Teclee el nombre del producto sanitario y se buscará en la base de datos"
                        },
                        on: {
                          hit: function($event) {
                            _vm.selectedMedication = $event
                          },
                          input: _vm.onKeywordChanged
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "suggestion",
                              fn: function(ref) {
                                var data = ref.data
                                var htmlText = ref.htmlText
                                return [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-sm" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(htmlText)
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          585281165
                        ),
                        model: {
                          value: _vm.productoSanitarioSearch,
                          callback: function($$v) {
                            _vm.productoSanitarioSearch = $$v
                          },
                          expression: "productoSanitarioSearch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 3
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "input-group-5",
                        label: "Producto nutricional:",
                        "label-for": "input-medicament"
                      }
                    },
                    [
                      _c("vue-bootstrap-typeahead", {
                        attrs: {
                          data: _vm.medications,
                          serializer: function(s) {
                            return s.nombreComercial
                          },
                          maxMatches: _vm.maxMatches,
                          placeholder:
                            "Teclee el nombre del producto nutricional y se buscará en el vademecum"
                        },
                        on: {
                          hit: function($event) {
                            _vm.selectedMedication = $event
                          },
                          input: _vm.onKeywordChanged
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "suggestion",
                              fn: function(ref) {
                                var data = ref.data
                                var htmlText = ref.htmlText
                                return [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-sm" }, [
                                      _c("div", { staticClass: "row" }, [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(htmlText)
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          585281165
                        ),
                        model: {
                          value: _vm.medicationSearch,
                          callback: function($$v) {
                            _vm.medicationSearch = $$v
                          },
                          expression: "medicationSearch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 4
                ? _c(
                    "b-row",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "treatmentStartDate" } },
                            [_vm._v("Descripción de la fórmula:")]
                          ),
                          _vm._v(" "),
                          _c("base-textarea", {
                            staticClass: "mb-0",
                            attrs: {
                              maxlength: "40",
                              label: _vm.Formula,
                              rows: 3,
                              maxRows: 9
                            },
                            model: {
                              value: _vm.newMedication.formula,
                              callback: function($$v) {
                                _vm.$set(_vm.newMedication, "formula", $$v)
                              },
                              expression: "newMedication.formula"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.medicationCombo.selected == 5
                ? _c(
                    "b-row",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "label",
                            { attrs: { for: "treatmentStartDate" } },
                            [_vm._v("Descripción de la vacuna:")]
                          ),
                          _vm._v(" "),
                          _c("base-textarea", {
                            staticClass: "mb-0",
                            attrs: {
                              maxlength: "40",
                              label: _vm.VacunaInd,
                              rows: 3,
                              maxRows: 9
                            },
                            model: {
                              value: _vm.newMedication.vaccine,
                              callback: function($$v) {
                                _vm.$set(_vm.newMedication, "vaccine", $$v)
                              },
                              expression: "newMedication.vaccine"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", { attrs: { for: "dispensingDate" } }, [
                      _vm._v("Fecha de dispensación:")
                    ]),
                    _vm._v(" "),
                    _c("b-form-datepicker", {
                      attrs: {
                        id: "dispensingDate",
                        placeholder: "Seleccione una fecha",
                        locale: _vm.dateLocale,
                        "date-format-options": _vm.dateFormatOptions
                      },
                      model: {
                        value: _vm.newMedication.dispensingDate,
                        callback: function($$v) {
                          _vm.$set(_vm.newMedication, "dispensingDate", $$v)
                        },
                        expression: "newMedication.dispensingDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 pl-2" },
                  [
                    _c("label", { attrs: { for: "packagesNumber" } }, [
                      _vm._v("Número de envases:")
                    ]),
                    _vm._v(" "),
                    _c("base-spin-input", {
                      attrs: {
                        id: "packagesNumber",
                        min: "1",
                        max: "200",
                        step: "1",
                        readonly:
                          _vm.medicationCombo.selected == 4 ||
                          _vm.medicationCombo.selected == 5
                      },
                      model: {
                        value: _vm.newMedication.packagesNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.newMedication, "packagesNumber", $$v)
                        },
                        expression: "newMedication.packagesNumber"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.medicationCombo.selected == 1
                ? _c(
                    "div",
                    { attrs: { id: "tratamiento" } },
                    [
                      _c("b-row", { attrs: { cols: "6" } }, [
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("label", { attrs: { for: "doseNumber" } }, [
                              _vm._v("Dosis por toma:")
                            ]),
                            _vm._v(" "),
                            _c("base-spin-input", {
                              attrs: {
                                id: "doseNumber",
                                min: "1",
                                max: "200",
                                step: "1"
                              },
                              model: {
                                value: _vm.newMedication.doseNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.newMedication, "doseNumber", $$v)
                                },
                                expression: "newMedication.doseNumber"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 pl-2" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "doseFrequencyNumber" } },
                              [_vm._v("Frecuencia:")]
                            ),
                            _vm._v(" "),
                            _c("base-spin-input", {
                              attrs: {
                                id: "doseFrequencyNumber",
                                min: "1",
                                max: "200",
                                step: "1"
                              },
                              model: {
                                value: _vm.newMedication.doseFrequencyNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.newMedication,
                                    "doseFrequencyNumber",
                                    $$v
                                  )
                                },
                                expression: "newMedication.doseFrequencyNumber"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-row", { attrs: { cols: "6" } }, [
                        _c(
                          "div",
                          { staticClass: "col-6" },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.doseUnitMeasureOptions },
                              model: {
                                value: _vm.doseUnitMeasureSelected,
                                callback: function($$v) {
                                  _vm.doseUnitMeasureSelected = $$v
                                },
                                expression: "doseUnitMeasureSelected"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 pl-2" },
                          [
                            _c("b-form-select", {
                              staticClass: "m",
                              attrs: { options: _vm.frequencyMeasureOptions },
                              model: {
                                value: _vm.frequencyMeasureSelected,
                                callback: function($$v) {
                                  _vm.frequencyMeasureSelected = $$v
                                },
                                expression: "frequencyMeasureSelected"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("b-row", { attrs: { cols: "6" } }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", { attrs: { for: "treatmentStartDate" } }, [
                      _vm._v("Inicio del tratamiento:")
                    ]),
                    _vm._v(" "),
                    _c("b-form-datepicker", {
                      staticClass: "form-group",
                      attrs: {
                        id: "treatmentStartDate",
                        placeholder: "Seleccione una fecha",
                        "date-format-options": _vm.dateFormatOptions
                      },
                      model: {
                        value: _vm.newMedication.treatmentStartDate,
                        callback: function($$v) {
                          _vm.$set(_vm.newMedication, "treatmentStartDate", $$v)
                        },
                        expression: "newMedication.treatmentStartDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 pl-2" },
                  [
                    _c("label", { attrs: { for: "treatmentEndDate" } }, [
                      _vm._v("Fin del tratamiento:")
                    ]),
                    _vm._v(" "),
                    _c("b-form-datepicker", {
                      staticClass: "form-group",
                      attrs: {
                        id: "treatmentEndDate",
                        placeholder: "Seleccione una fecha",
                        "date-format-options": _vm.dateFormatOptions
                      },
                      model: {
                        value: _vm.newMedication.treatmentEndDate,
                        callback: function($$v) {
                          _vm.$set(_vm.newMedication, "treatmentEndDate", $$v)
                        },
                        expression: "newMedication.treatmentEndDate"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "treatmentStartDate" } }, [
                        _vm._v("Observaciones:")
                      ]),
                      _vm._v(" "),
                      _c("base-textarea", {
                        attrs: {
                          label: _vm.Observaciones,
                          rows: 3,
                          maxRows: 9
                        },
                        model: {
                          value: _vm.newMedication.observations,
                          callback: function($$v) {
                            _vm.$set(_vm.newMedication, "observations", $$v)
                          },
                          expression: "newMedication.observations"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.detailMedicationVisible
            ? _c(
                "b-col",
                {
                  staticClass: "pl-3",
                  attrs: { id: "medicationDetail", cols: "6" }
                },
                [
                  _c("label", { staticClass: "text-left" }, [
                    _vm._v("Información:")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-link",
                    {
                      staticStyle: { float: "right" },
                      attrs: {
                        size: "sm",
                        href: "#",
                        variant: "secondary",
                        "align-h": "end"
                      },
                      on: { click: _vm.closeMedicationDetail }
                    },
                    [
                      _c("b-icon", {
                        attrs: { "font-scale": "1", icon: "x-square" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        title: _vm.selectedMedication.nombreComercial,
                        "img-src":
                          _vm.selectedMedication.urlImagenEnvase != null
                            ? _vm.selectedMedication.urlImagenEnvase
                            : "/static/img/medicamento-generico.jpeg",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("b-card-text", [
                        _c("small", [
                          _vm._v(
                            "Laboratorio:\n                  " +
                              _vm._s(
                                _vm.selectedMedication.laboratorio
                                  .nombreComercializador
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "Presentación:\n                  " +
                              _vm._s(
                                _vm.selectedMedication.unidadesContenido +
                                  " " +
                                  _vm.selectedMedication.formafarmaceutica
                                    .nombreSimplificado
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [_vm._v("Vias de administración:")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.selectedMedication.formafarmaceutica
                              .viasAdministracion,
                            function(data) {
                              return _c("li", { key: data.codigo }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(data.nombre) +
                                    "\n                "
                                )
                              ])
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c("small", [_vm._v("Principios activos:")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.selectedMedication.formafarmaceutica
                              .principiosActivos,
                            function(data) {
                              return _c("li", { key: data.codigo }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(data.nombre) +
                                    "\n                "
                                )
                              ])
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _vm.selectedMedication.formafarmaceutica.excipientes
                          .length > 0
                          ? _c("small", [_vm._v("Excipientes:")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.selectedMedication.formafarmaceutica
                              .excipientes,
                            function(data) {
                              return _c("li", { key: data.codigo }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(data.nombre) +
                                    "\n                "
                                )
                              ])
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _vm.selectedMedication.conReceta ||
                        _vm.selectedMedication.psicotropo ||
                        _vm.selectedMedication.estupefaciente ||
                        _vm.selectedMedication.afectaConduccion ||
                        _vm.selectedMedication.trianguloNegro ||
                        _vm.selectedMedication.usoHospitalario
                          ? _c("small", [_vm._v("Características:")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("ul", [
                          _vm.selectedMedication.conReceta
                            ? _c("li", { staticClass: "text-danger" }, [
                                _vm._v("NECESITA RECETA")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedMedication.psicotropo
                            ? _c(
                                "li",
                                { staticClass: "text-danger blink_me" },
                                [_vm._v("PSICOTROPO")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedMedication.estupefaciente
                            ? _c(
                                "li",
                                { staticClass: "text-danger blink_me" },
                                [_vm._v("ESTUPEFACIENTE")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedMedication.afectaConduccion
                            ? _c("li", { staticClass: "text-danger" }, [
                                _vm._v("AFECTA A LA CONDUCCIÓN")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedMedication.trianguloNegro
                            ? _c("li", { staticClass: "text-danger" }, [
                                _vm._v("NECESITA SEGUIMIENTO ADICIONAL")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedMedication.usoHospitalario
                            ? _c("li", { staticClass: "text-danger" }, [
                                _vm._v("USO HOSPITALARIO")
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-100 mt-4" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "outline-info",
                                target: "_blank",
                                href: _vm.selectedMedication.urlProspecto
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  "shift-v": "5",
                                  "font-scale": "0.8",
                                  icon: "box-arrow-up-right"
                                }
                              }),
                              _vm._v("Prospecto")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "outline-info",
                                target: "_blank",
                                href: _vm.selectedMedication.urlFichaTecnica
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  "shift-v": "5",
                                  "font-scale": "0.8",
                                  icon: "box-arrow-up-right"
                                }
                              }),
                              _vm._v("Fecha técnica")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37077dd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37077dd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/prescription.vue
// module id = 3895
// module chunks = 28